import React, { useState } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { truncate } from "../../CommonMethhods/CommonMethods";

function LTCGReportTable(props) {
  const data = props.data;

  const showLtcgData = (data) => {
    return (
      data &&
      data.map((item, index) => {
        return (
          <tr key={index}>
            <td>
              {item.tradeDate === "" || undefined || null
                ? "-"
                : item.tradeDate}
            </td>
            <td>
              {item.symbol === "" || undefined || null
                ? "-"
                : item.symbol}
            </td>
            <td>
              {item.totalQty === "" || undefined || null
                ? "-"
                : item.totalQty}
            </td>
            <td>
              {item.closingPrice === "" || undefined || null
                ? "-"
                : item.closingPrice}
            </td>
            <td>
              {item.currentAmt === "" || undefined || null ? "-" : item.currentAmt}
            </td>
            <td>
              {item.daysLeft === "" || undefined || null
                ? "-"
                : item.daysLeft}
            </td>
            <td>
              {item.shortTermTax === "" || undefined || null
                ? "-"
                : item.shortTermTax}
            </td>
            <td>
              {item.longTermTax === "" || undefined || null
                ? "-"
                : item.longTermTax}
            </td>
            <td>
              {item.unRealizedPnl === "" || undefined || null
                ? "-"
                : item.unRealizedPnl}
            </td>
          </tr>
        );
      })
    );
  };
  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        {data && data.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                {/* {Object.keys(data[0]).map((value, index) => {
                  return (
                    <th key={index} className="snapshot-table-column">
                      {value}
                    </th>
                  );
                })} */}
                <th scope="col" className="text-center">
                  {Constants.Trade_Date}
                </th>
                <th scope="col">Symbol</th>
                <th scope="col" className="text-center">
                  Total Qty
                </th>
                <th scope="col" className="text-center">
                  Closing Price
                </th>
                
                <th scope="col" className="text-center">
                  Current Amt
                </th>
                <th scope="col" className="text-center">
                  Days Left
                </th>
                <th scope="col" className="text-center">
                Short term tax
                 <div className="tooltip123">
                 
                  {truncate(<span className="icon-info-icon short-tax"></span>)}
                  
                  <div className="tooltiptext tooltip-tax">
                  15% Approx
                  </div>
                  </div>
                </th>
                <th scope="col" className="text-center">
                Long term tax
                 <div className="tooltip123">
                 
                  {truncate(<span className="icon-info-icon short-tax"></span>)}
                  
                  <div className="tooltiptext tooltip-tax">
                  10% Approx
                  </div>
                  </div>
                </th>

                <th scope="col" className="text-center">
                  Unrealized P&L
                </th>
              </tr>
            </thead>
            <tbody>{showLtcgData(data)}</tbody>
          </table>
        ) : (
          <div className="report-error-message">
            {Constants.Ltcg_Report_dosnt_exist}
          </div>
        )}
      </div>
    </>
  );
}
export default LTCGReportTable;
